import { jwtDecode } from "jwt-decode";
import axiosInstance from "../services/axiosInterceptors";
import apiEndPointsConfig from "../services/apiEndPoints";
import { ADMIN_SESSION_KEY } from "./impersonationConstants";

export { ADMIN_SESSION_KEY };

export function getImpersonationInfo(token = localStorage.getItem("token")) {
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    if (!decoded?.impersonatedBy) return null;
    return {
      impersonatedByName: decoded.impersonatedByName,
      targetUserName: decoded.userName,
      exp: decoded.exp,
    };
  } catch {
    return null;
  }
}

export async function startImpersonation(employeeId, companyId) {
  const token = localStorage.getItem("token");
  const res = await axiosInstance.post(
    `${apiEndPointsConfig.impersonateUser}/${employeeId}/impersonate`,
    companyId ? { companyId } : {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const newToken = res?.data?.data?.token;
  if (!newToken) throw new Error("Impersonation failed: no token returned.");

  localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify({ token }));
  localStorage.setItem("token", newToken);
  window.location.href = "/";
}

export async function endImpersonation() {
  const token = localStorage.getItem("token");
  try {
    // Best-effort — a backend hiccup here must never trap the admin in the
    // impersonated session, so failures are logged, not thrown.
    await axiosInstance.post(
      apiEndPointsConfig.endImpersonation,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (err) {
    console.error("Failed to close impersonation audit log (restoring admin session anyway):", err);
  }

  const stash = localStorage.getItem(ADMIN_SESSION_KEY);
  localStorage.removeItem(ADMIN_SESSION_KEY);
  if (stash) {
    localStorage.setItem("token", JSON.parse(stash).token);
  } else {
    localStorage.removeItem("token");
  }
  window.location.href = "/";
}
